import Image from 'next/image'
import cn from 'classnames'
import { Tile, TileCaption, TileOverlay } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { reportError } from '@mc/next-newrelic'
import { PricingText } from 'components/PricingText'
import { usePageData } from '../PageDataProvider'
import { Cta } from './Cta'
import { BACKGROUND_IMAGES_CATEGORIES } from './backgroundImages'
import { useDynamicCategoryHeadlines } from './useDynamicCategoryHeadlines'
import styles from './Hero.module.scss'

export const HeroDesktop = () => {
  const { slug, category } = usePageData()
  const { t } = useTranslation('@mc/next')
  const { headline, subheadline } = useDynamicCategoryHeadlines()

  if (category === null) {
    reportError('Category not found in HeroDesktop')
    return null
  }

  return (
    <div className={cn('d-none d-md-none d-lg-block', styles.wrapper)}>
      <Tile aspectRatio='21x9' className={styles.tileDesktop}>
        <TileCaption position='left top' padding={0}>
          <div className={`${styles.headline} mc-mt-12`}>
            <h1 className='mc-text-d3 mc-text--brand mc-text--uppercase mc-text--center mc-text-md--left mc-mb-3'>
              {headline}
            </h1>
            <h2 className='mc-text-h3 mc-text--center mc-text-md--left mc-my-5 mc-mb-6'>
              {subheadline}
            </h2>
            <div className='row justify-content-start mc-text--left align-items-start'>
              <div className='col-auto'>
                <Cta slug={slug} />
              </div>
              <PricingText
                translationKey='long'
                className='col-3 mc-text-small mc-opacity--hinted'
              />
            </div>
          </div>
        </TileCaption>

        <div
          className='position-relative d-flex align-items-end'
          role='group'
          aria-label={t('categories.categoryPage.hero.a11y.someInstructors', {
            categoryName: category?.name,
          })}
        >
          <TileOverlay color='0,0,0' />
          <div className='mc-mr-2'>
            <Image
              priority
              src={BACKGROUND_IMAGES_CATEGORIES[slug].img1}
              alt={BACKGROUND_IMAGES_CATEGORIES[slug].img1Alt}
              width={360}
              height={420}
              style={{ objectPosition: 'top', objectFit: 'cover' }}
              className='mc-corners--2'
            />
          </div>
          <Image
            priority
            src={BACKGROUND_IMAGES_CATEGORIES[slug].img2}
            alt={BACKGROUND_IMAGES_CATEGORIES[slug].img2Alt}
            width={360}
            height={500}
            style={{ objectPosition: 'top', objectFit: 'cover' }}
            className='mc-corners--2'
          />
        </div>
      </Tile>
    </div>
  )
}
